import React, { useEffect, useState } from "react";
import "../../Styles/Parentsnotification.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify";

export default function Parentnotification() {
    const [isLoading, setIsLoading] = useState(false);
    
    // State to manage individual checkbox values
    const [settings, setSettings] = useState({
        busfare: false,
        cashless: false,
        fee_reminder1: false,
        fee_reminder2: false,
        fee_reminder3: false,
        notification_settings_failed_transaction: false,
    });

    useEffect(() => {
        notificationgetSettings();
    }, []);

    // Helper to handle checkbox changes
    const handleCheckboxChange = (e) => {
        const { id, checked } = e.target;
        setSettings((prev) => ({
            ...prev,
            [id]: checked
        }));
    };

    const notificationgetSettings = async () => {
        setIsLoading(true);
        const customer_id = localStorage.getItem("customer_id");
        const api_key = localStorage.getItem("api_key");

        const requestBody = {
            customer_id: Number(customer_id),
            api_key: api_key,
            language: "en",
            user_id: localStorage.getItem("user_id") || "" 
        };

        try {
            const response = await simplePostCall(ApiConfig.parentintegrationsettingsget, JSON.stringify(requestBody));

            if (response?.result && response?.model?.length > 0) {
                const data = response.model[0];
                // Mapping API 1/0 to Boolean
                setSettings({
                    busfare: data.notification_settings_busfare === 1,
                    cashless: data.notification_settings_cashless === 1,
                    fee_reminder1: data.notification_settings_fee_reminder1 === 1,
                    fee_reminder2: data.notification_settings_fee_reminder2 === 1,
                    fee_reminder3: data.notification_settings_fee_reminder3 === 1,
                    notification_settings_failed_transaction: data.notification_settings_failed_transaction === 1,
                });
            }
        } catch (error) {
            console.error("Error loading settings:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const notificationgetSettingsUpdate = async () => {
        setIsLoading(true);
        const customer_id = localStorage.getItem("customer_id");
        const api_key = localStorage.getItem("api_key");
        const user_id = localStorage.getItem("user_id");

        // Constructing the specific payload format you requested
        const requestBody = {
            customer_id: Number(customer_id),
            api_key: api_key,
            language: "en",
            user_id: Number(user_id),
            activity_type: "UPDATE",
            activity_action: "Notification Settings Updated",
            NotificationSettings: [
                {
                    settings_busfare: settings.busfare ? 1 : 0,
                    settings_cashless: settings.cashless ? 1 : 0,
                    settings_fee_reminder1: settings.fee_reminder1 ? 1 : 0,
                    settings_fee_reminder2: settings.fee_reminder2 ? 1 : 0,
                    settings_fee_reminder3: settings.fee_reminder3 ? 1 : 0,
                    notification_settings_failed_transaction: settings.notification_settings_failed_transaction ? 1 : 0
                }
            ]
        };

        try {
            const response = await simplePostCall(ApiConfig.parentintegrationsettingsUpdate, JSON.stringify(requestBody));

            if (response?.result) {
                toast.success("Well done! Notification Settings saved successfully");
                notificationgetSettings()
            } else {
                toast.error("Failed to update settings");
            }
        } catch (error) {
            console.error("Error updating settings:", error);
             toast.error("Error updating settings")
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="parentnotification-container">
            <ToastContainer />
            <div className="special-header panel-white-all">
                <h4 className="page-title">Parents Notification Settings</h4>
            </div>

            <div className="yc-list-body">
                <div className="card">
                    <div className="card-body">
                        <div className="row g-3">
                            {/* Busfares Checkbox */}
                            <div  className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="busfare"
                                    className="big-checkbox"
                                    checked={settings.busfare}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="busfare" className="custom-checkbox-label">
                                    Busfare Payment Reminder
                                </label>
                            </div>

                            {/* Cashless Checkbox */}
                            <div className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                
                                    type="checkbox"
                                    id="cashless"
                                    className="big-checkbox"
                                    checked={settings.cashless}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="cashless" className="custom-checkbox-label">
                                    Cashless System Daily Spend Report
                                </label>
                            </div>

                            {/* Reminder 1 */}
                            <div className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="fee_reminder1"
                                    className="big-checkbox"
                                    checked={settings.fee_reminder1}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="fee_reminder1" className="custom-checkbox-label">
                                    First Pending Fee Reminder (Parents)
                                </label>
                            </div>

                            {/* Reminder 2 */}
                            <div className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="fee_reminder2"
                                    className="big-checkbox"
                                    checked={settings.fee_reminder2}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="fee_reminder2" className="custom-checkbox-label">
                                    Second Pending Fee Reminder (Parents)
                                </label>
                            </div>

                            {/* Reminder 3 */}
                            <div className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="fee_reminder3"
                                    className="big-checkbox"
                                    checked={settings.fee_reminder3}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="fee_reminder3" className="custom-checkbox-label">
                                    Final Pending Fee Reminder (Parents, Accountant)
                                </label>
                            </div>


                             <div className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="notification_settings_failed_transaction"
                                    className="big-checkbox"
                                    checked={settings.notification_settings_failed_transaction}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="notification_settings_failed_transaction" className="custom-checkbox-label">
                                    Failed Transaction Alert (Parent, Accountant)
                                </label>
                            </div>

                            <div className="col-12 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary"
                                    onClick={notificationgetSettingsUpdate}
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Updating..." : "Update"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}